@if(loader){
<app-loader></app-loader>
}

<p-card [header]="(isEdit===true)?'Update Quote':'Create Quote' ">

    <form [formGroup]="createQuoteForm">


        <div class="field col-12 flex justify-content-between align-items-center">
            <div class="flex justify-content-start">
                @if(isEdit){
                <p-button label="Update" severity="info" (click)="update()" icon="pi pi-arrow-circle-up"
                    size="small"></p-button>
                }@else {
                <p-button label="Save" pTooltip="Create Quote" icon="pi pi-save" size="small"
                    (click)="validateSalesOrder('QUOTE')"></p-button>
                <div>
                    <p-button label="Reset" (click)="resetForm()" class="p-button-outlined ml-2 " icon="pi pi-replay"
                        severity="info" size="small"></p-button>
                </div>
                }
                <p-button label="Move To Order" icon="pi pi-box" (click)="movetoOrder()" *ngIf="isEdit" severity="info"
                    size="small" class="p-button-sm ml-2"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="Cancel()"
                    class="p-button-sm ml-2"></p-button>
            </div>

            <div>
                <label class="block label-required" style="font-weight: bold;">Required Field</label>
            </div>
        </div>


        <div class="grid mt-3">


            <div class="col">

                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Quote No</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText formControlName="QuoteNo" placeholder="e.g 89098" type="text"
                            (blur)="checkOrderNumber()"
                            [readonly]="isEdit || !this.createQuoteForm.controls.manualEntry.value || products.length > 0"
                            class="w-full"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.QuoteNo.errors }"
                            (keydown.enter)="focusNextInput($event)" />
                        @if (!isEdit) { <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" *ngIf="products.length == 0"
                                (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                value="true"></p-checkbox>
                        </div>
                        }
                    </div>
                </div>
                <div class="field text-left">
                    <label class="label-required display">Expiration Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="QuoteExpiration"
                            styleClass="w-full" [showIcon]="true"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.QuoteExpiration.errors}"
                            (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                </div>
                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}}</label>
                    <p-autoComplete formControlName="warehouse" [dropdown]="(products.length > 0) ? false : true"
                        [readonly]="products.length > 0" (onSelect)="setWarehouse($event)" [forceSelection]="true"
                        [suggestions]="filterWarehouses" (completeMethod)="filterWarehouse($event)"
                        field="warehouseName" placeholder="Search {{ unitLabel }}" styleClass="w-full" [ngClass]="{
                         'ng-invalid ng-dirty': submitted && formControls.warehouse.errors
                         }" (keydown.enter)="focusNextInput($event)"><ng-template let-item pTemplate="item"> <span>{{
                                item.warehouseCode }} - {{ item.warehouseName }}</span>
                        </ng-template>

                    </p-autoComplete>
                </div>

                <div class="field text-left">
                    <label for="supplyType" class="label-required display">Supply Type</label>
                    <input pInputText readonly formControlName="supplyType" class="w-full"
                        (keydown)="onKeydown($event,products)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.supplyType.errors}" />
                </div>


                <div class="field text-left flex align-items-center gap-3">

                    <div
                        *ngIf="createQuoteForm.value.supplyType === 'EXPORT' || createQuoteForm.value.supplyType === 'SEZ'">
                        <p-checkbox formControlName="isLUT" [binary]="true" label="Supply under LUT (No GST)"
                            [readonly]="isOpenStatus" (onChange)="onLUTChange($event)">
                        </p-checkbox>
                    </div>


                    <div *ngIf="showRCM">
                        <p-checkbox formControlName="isRCM" [binary]="true" label="Reverse Charge (RCM)"
                            [readonly]="isOpenStatus" (onChange)="onRCMChange($event)">
                        </p-checkbox>
                    </div>

                </div>

                <div class="field text-left">
                    <div *ngIf="isExportOrSEZ()" class="field">

                        <label>Export Type</label>
                        <div class="p-2 border-round surface-100">
                            {{ getExportTypeLabel() }}
                        </div>

                    </div>

                </div>


                <div class="field text-left">
                    <label for="SalespersonCode" class="label-required display">Salesperson</label>
                    <div class="p-inputgroup p-lookup">
                        <input pInputText formControlName="salesperson" (click)="showSalesperson()" readonly
                            class="w-full"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.salesperson.errors }"
                            (keydown)="onKeydown($event,products)" />
                        <button type="button" [disabled]="products.length > 0" pButton pRipple
                            (click)="showSalesperson()" icon="pi pi-search" styleClass="p-button-warn"></button>
                    </div>
                </div>


            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="BillToCustomerCode" class="label-required display">Bill To Customer Code</label>
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="BillToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setBillTo($event)" [suggestions]="BillTocustomerList"
                                [forceSelection]="true" (completeMethod)="autosearchBilltoCustomer($event)"
                                field="customerCode" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.BillToCustomerCode.errors }"
                                (keydown.enter)="focusNextInput($event)">

                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" [disabled]="products.length > 0" pButton pRipple
                                (click)="showBillToCustomerDialog()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                            <p-button (click)="createQuickCustomer(true)" [disabled]="products.length > 0"
                                class="p-button-outlined ml-2 " icon="pi pi-user-plus" severity="info"></p-button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="BillToCustomer">Bill To Customer Name</label>
                    <input pInputText readonly formControlName="BillToCustomer" class="w-full"
                        (keydown.enter)="focusNextInput($event)" />
                </div>

                <div class="field text-left">
                    <label for="BillToCustomerAddress">Address</label>
                    <input pInputText formControlName="BillToCustomerAddress" class="w-full"
                        (keydown.enter)="focusNextInput($event)" />
                </div>

                <div class="field text-left">
                    <label for="requestedDate" class="label-required display">Requested Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="requestedDate"
                            [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                </div>

            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="ShipToCustomerCode" class="label-required display">Ship To Customer Code</label>
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="products.length > 0"
                                [forceSelection]="true" (onSelect)="setShipTo($event)"
                                [suggestions]="ShipTocustomerList" (completeMethod)="autosearchShiptoCustomer($event)"
                                field="customerCode" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }"
                                (keydown)="onKeydown($event,products)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" [disabled]="products.length > 0" pButton pRipple
                                (click)="openShipToCustomerLookup()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                            <p-button (click)="createQuickCustomer(false)" [disabled]="products.length > 0"
                                class="p-button-outlined ml-2 " icon="pi pi-user-plus" severity="info"></p-button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomer">Ship To Customer Name</label>
                    <input pInputText formControlName="ShipToCustomer" readonly class="w-full"
                        (keydown.enter)="focusNextInput($event)" />
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomerAddress">Address</label>
                    <input pInputText formControlName="ShipToCustomerAddress" class="w-full"
                        (keydown)="onKeydown($event,products)" />
                </div>

                <div class="field text-left">
                    <label for="orderDate" class="label-required display">Order Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="orderDate"
                            [showIcon]="true" placeholder="Select Date" [disabled]="isEdit"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.orderDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                </div>

            </div>

        </div>

        <p-tabView [(activeIndex)]="activeIndex">

            <p-tabPanel header="Order Lines">

                <div class="grid align-items-center">

                </div>

                <div class="grid">

                    <div class="col-fixed" style="width: 150px; display: flex; align-items: center;">
                        <p-button icon="pi pi-plus" (onClick)="createQuickProduct()" [link]="true" label="New Product"
                            [size]="'small'" [style]="{'white-space':'nowrap'}"></p-button>
                    </div>

                    <div class="col" #productCodeAutoComplete>
                        <div class="field text-left " style="display: flex; align-items: center; margin-bottom: 0;">

                            <p-image [src]="previewImage" alt="product" width="40" [preview]="true"></p-image>

                            <p-autoComplete #productCodeInputRef formControlName="productCode"
                                placeholder="Search Product Code" [style]="{'width':'200px','height':'40px'}"
                                [inputStyle]="{'width':'200px','height':'40px'}" (onSelect)="setProduct($event)"
                                [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                                field="customerCode" (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item" class="text-left">
                                    <span>{{item.productCode}} - {{item.productName}}</span>
                                </ng-template>

                            </p-autoComplete>

                            <div style="margin-left: 0px; text-align: center; min-width: 80px;">
                                <p style="margin: 0; font-weight: bold; font-size: 14px; white-space: nowrap;">Q-Avail
                                </p>
                                <p style="margin: 0; font-size: 14px; white-space: nowrap;">{{QAvail}}</p>
                            </div>

                        </div>
                    </div>

                    <div class="col">
                        <input pInputText formControlName="productDescription" readonly placeholder="Product Name"
                            class="w-full" style="height: 40px;" (keydown.enter)="focusNextInput($event)" />
                    </div>

                    <div class="col">
                        <div class="field text-left" style="display: flex; align-items: center; margin-bottom: 0;">
                            <span style="margin-right: 10px;">
                                <input pInputText id="Qty" type="number" [formControlName]="getFormControlName()"
                                    [placeholder]="getPlaceholder()" min="0" style="width: 10x; height: 40px;"
                                    (keydown.enter)="focusNextInput($event)" />
                            </span>
                            <p-button label="Add" (onClick)="addProduct()"
                                [disabled]="!createQuoteForm.controls.productCode.value ||
                                !createQuoteForm.controls.productDescription.value ||
                                !(productCostCalculationType === 'qty' ? createQuoteForm.controls.productQty.value : createQuoteForm.controls.productWgt.value)"
                                [raised]="true" [size]="'small'" severity="info"></p-button>
                            <span style="margin-left: 10px;">
                                <p-button icon="pi pi-trash" (onClick)="deleteProduct()"
                                    [disabled]="selectedProduct.length === 0" [raised]="true" [size]="'small'"
                                    severity="danger"></p-button>
                            </span>

                        </div>
                    </div>
                </div>

                <p-table #dt1 [value]="products" responsiveLayout="scroll" class="w-full m-5"
                    styleClass="p-datatable-sm" [rowHover]="true" [paginator]="true" [rows]="5"
                    [rowsPerPageOptions]="[5, 10, 20]" [paginator]="true" [(selection)]="selectedProduct">
                    <ng-template pTemplate="header">
                        <tr>
                            <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                            <th>Sr No</th>
                            <th pSortableColumn="ProductCode">Code <p-sortIcon field="ProductCode"></p-sortIcon></th>
                            <th>Product Name </th>
                            <th>UOM </th>
                            <th></th>
                            <th>HSN/SAC</th>
                            <th>Qty</th>
                            <th>Price(₹)</th>
                            <th>Amount </th>
                            <th>Disc(%)</th>
                            <th>Net Amount(₹) </th>
                            <th>Gst%</th>
                            <!-- <th>Weight</th> -->
                            <th>Gst(₹)</th>
                            <th>Line Amount</th>
                            <th>Delivery Date</th>
                        <tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td>
                            <td>{{i+1}}</td>
                            <td [pEditableColumn]="product" pEditableColumnField="ProductCode"
                                class="text-blue-500 underline" style="cursor: pointer;" (click)="viewProduct(product)">
                                {{ product.ProductCode }}
                            </td>
                            <td>{{ product.ProductDescription }}</td>

                            <td [pEditableColumn]="product" [pEditableColumnField]="'uom'">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div class="p-inputgroup p-lookup">
                                            <input type="text" pInputText class="p-inputtext" [(ngModel)]="product.Uom"
                                                [ngModelOptions]="{ standalone: true }" [disabled]="true" />
                                            <button type="button" pButton pRipple icon="pi pi-search"
                                                styleClass="p-button-warn" (click)="showProductUom(product)"></button>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.Uom}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>

                            <td><span class="text-lg cursor-pointer" (click)="showSpecification(product)"><i
                                        class="pi pi-flag-fill"></i></span></td>

                            <td>{{product.HSNCode}}</td>

                            <td (click)="toggleEdit(product, 'QuotedQuantity')" [pEditableColumn]="product"
                                pEditableColumnField="QuotedQuantity">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" (blur)="onProductEdit(product)" min="1"
                                            class="p-inputtext-sm" [(ngModel)]="product.QuotedQuantity"
                                            [ngModelOptions]="{ standalone: true }"
                                            (keydown)="onKeydown($event,product)" *ngIf="isEditingQuantity" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ product.QuotedQuantity }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>



                            <td style="text-align: right;" [pEditableColumn]="product" pEditableColumnField="UnitPrice">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" class="p-inputtext-sm" min="0"
                                            [(ngModel)]="product.UnitPrice" (blur)="onProductEdit(product)"
                                            [ngModelOptions]="{ standalone: true }"
                                            (keydown)="onKeydown($event,product)" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        &nbsp;{{ product.UnitPrice.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2}) }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td style="text-align: right;"> {{product.ExtensionPrice.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>
                            <td style="text-align: right;" [pEditableColumn]="product" pEditableColumnField="Discount">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" class="p-inputtext-sm" min="0" max="100"
                                            [(ngModel)]="product.Discount" (keydown)="onKeydown($event, product)"
                                            (blur)="onProductEdit(product)" [ngModelOptions]="{ standalone: true }"
                                            [disabled]="isLineDiscountDisabled()" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.Discount}}%
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="col-divider" style="text-align: right;">
                                {{product.NetAmount?.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>

                            <td style="text-align: right;">{{product.GSTRate}}%</td>

                            <td style="text-align: right;">{{product.SalesTax.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>

                            <td class="col-divider text-right">{{product.LineTotal?.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>
                            <td style="max-width: 134px;">
                                <p-calendar [iconDisplay]="'input'" [(ngModel)]="product.deliveryDate"
                                    [ngModelOptions]="{ standalone: true }" dateFormat="dd/mm/yy"
                                    placeholder="Select Date" [showIcon]="true" styleClass="w-full" appendTo="body"
                                    (blur)="onProductEdit(product)" (keydown)="onKeydown($event, product)"
                                    (keydown.enter)="focusNextInput($event)"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && !product.deliveryDate}">
                                </p-calendar>
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="grid">
                            <div class="col-12 md:col-8">
                                <div class="grid formgrid">

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Header Discount(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="DiscountAmount">
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Freight Charges(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="FreightTotal">
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label class="block mb-2">Rate on Freight</label>
                                        <p-dropdown [options]="gstOptions" optionLabel="label" + optionValue="value"
                                            placeholder="Select GST" formControlName="RateOnFreight"
                                            styleClass="w-full">
                                        </p-dropdown>
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>GST on Freight(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="GSTOnFreight"
                                            readonly>
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 md:col-4">
                                <div class="col flex flex-column align-items-end">

                                    <div class="field text-left">
                                        CGST: ₹ {{CGSTtotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        SGST: ₹ {{SGSTtotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        IGST: ₹ {{IGSTtotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        Taxable: ₹ {{Taxable.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        Final Taxable Amount: ₹ {{FinalTaxableAmt.toLocaleString('en-IN', {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="hr-line w-full my-2"></div>
                                    <div
                                        style="display:flex; justify-content:flex-end; align-items:center; white-space:nowrap; font-weight:600;">

                                        <div style="margin-right:15px;">
                                            Total Qty:
                                            <span>{{ weightTotal.toLocaleString('en-IN', {minimumFractionDigits:
                                                2,maximumFractionDigits: 2})}}
                                            </span>
                                        </div>
                                        <div style="margin:0 15px;">|</div>

                                        <div>
                                            Total: ₹
                                            <span>{{ orderTotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                                maximumFractionDigits: 2})}}
                                            </span>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-table>

            </p-tabPanel>

            <p-tabPanel header="Other Details">

                <div class="grid">


                    <div class="col">

                        <div class="field text-left">
                            <label for="ReferenceNumber">Reference Number</label>
                            <input type="text" formControlName="ReferenceNumber" pInputText class="w-full"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>

                        <div class="field text-left">
                            <label>Customer PO Number</label>
                            <input type="text" formControlName="purchaseOrderNumber" pInputText class="w-full"
                                (keydown)="onKeydown($event,products)" />
                        </div>

                        <div class="field text-left">
                            <label for="Destination">Destination</label>
                            <input type="text" formControlName="Destination" pInputText class="w-full"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>

                        <div class="field text-left">
                            <label for="projectName">Project Name</label>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <input pInputText formControlName="projectName" readonly placeholder="Select Project"
                                    style="width: 200px;" />
                                <p-button icon="pi pi-search" (click)="getProjectLookup()" [raised]="true"
                                    [size]="'small'" severity="info" [disabled]="canEdit"></p-button>
                                <button *ngIf="createQuoteForm.get('projectName')?.value" type="button" pButton pRipple
                                    icon="pi pi-times" class="p-button-danger" severity="danger"
                                    (click)="clearProject()" title="Clear Project" [disabled]="canEdit"></button>
                            </div>
                        </div>
                    </div>

                    <div class="col">


                        <div class="field text-left">
                            <label>Expected Dispatch Date</label>
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="ShipmentDate"
                                styleClass="w-full" [showIcon]="true"></p-calendar>
                        </div>

                        <div class="field text-left">
                            <label>Customer PO Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="CustomerPODate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"
                                (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>

                        <div class="field text-left">
                            <label for="TermsOfDelivery">Terms Of Delivery</label>
                            <textarea rows="3" pInputTextarea formControlName="TermsOfDelivery"
                                class="w-full"></textarea>
                        </div>

                    </div>

                    <div class="col">


                        <div class="field text-left">
                            <label for="TermsCode">Payment Terms</label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText formControlName="TermsCode" readonly class="w-full"
                                    (keydown)="onKeydown($event,products)" />
                                <button type="button" pButton pRipple (click)="showTermsCode()" icon="pi pi-search"
                                    styleClass="p-button-warn"></button>
                            </div>
                        </div>

                        <div class="field text-left">
                            <label for="deliveryNote">Delivery Note</label>
                            <textarea rows="3" pInputTextarea formControlName="deliveryNote" class="w-full"></textarea>
                        </div>


                    </div>

                </div>

            </p-tabPanel>

        </p-tabView>

    </form>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>